// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"bb1f5f892f034ddb2aa4","678":"a3bf1b9875b41cb17f0e","883":"2cc0ad0b7b6f20e1f17c"}[chunkId] + ".js";
};